export default "__VITE_PUBLIC_ASSET__48f819b6__"